import { render, staticRenderFns } from "./whyeatseasonally.vue?vue&type=template&id=5465623b&scoped=true&"
var script = {}
import style0 from "./whyeatseasonally.vue?vue&type=style&index=0&id=5465623b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5465623b",
  null
  
)

export default component.exports